import SubmitPage from 'components/rentingRedRac/Purchase/formPages/SubmitPage';
import InitialPage from 'components/rentingRedRac/Purchase/formPages/InitialPage';

export default [InitialPage, SubmitPage];
